import {
    KEYCLOAK,
    KEYCLOAK_ERROR,
    KEYCLOAK_SUCCESS
} from "../constants/keyCloakConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function keyCloakReducer(state = initialState, action) {
    switch (action.type) {
        case KEYCLOAK:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''

            });
        case KEYCLOAK_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case KEYCLOAK_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'keyCloakData': action.data

            });
        default:
            return state;
    }
};

export default keyCloakReducer